import React, { useState } from 'react';
import axios from 'axios';
import { engineUseCrops, engineUseMaintenance } from './config';
import RenderError from '../../components/RenderError';
import Success from '../../../equipmentSurveys/components/Success';
import Submit from '../../../equipmentSurveys/components/Submit';

function CurrentPractices({
  applicationData: {
    aid,
    crops,
    numberOfEngines,
    operationHoursPerYear,
    operationGallonsPerHour,
    maintenance,
    maintenanceProvider
  },
  setApplicationData,
  initialView,
  setView
}) {
  const [formData, setFormData] = useState({
    aid: aid ?? '',
    crops: crops ?? {},
    numberOfEngines: parseInt(numberOfEngines) ?? '',
    operationHoursPerYear: parseInt(operationHoursPerYear) ?? '',
    operationGallonsPerHour: parseInt(operationGallonsPerHour) ?? '',
    maintenance: maintenance ?? {},
    maintenanceProvider: maintenanceProvider ?? ''
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleCheckCrop = (event) => {
    const { value } = event.target;

    if (value in formData.crops) {
      let newFormData = formData.crops;
      delete newFormData[value];
      setFormData({ ...formData, crops: newFormData });
    } else {
      setFormData({ ...formData, crops: { ...formData.crops, [value]: 0 } });
    }
  };

  const handleCheckTask = (event) => {
    const { value } = event.target;

    if (value in formData.maintenance) {
      let newFormData = formData.maintenance;
      delete newFormData[value];
      setFormData({ ...formData, maintenance: newFormData });
    } else {
      setFormData({
        ...formData,
        maintenance: { ...formData.maintenance, [value]: '' }
      });
    }
  };

  const setCropAcres = (event, crop) => {
    const { value } = event.target;
    setFormData({
      ...formData,
      crops: { ...formData.crops, [crop]: parseInt(value) }
    });
  };

  const setMaintenanceInterval = (event, task) => {
    const { value } = event.target;
    setFormData({
      ...formData,
      maintenance: { ...formData.maintenance, [task]: value }
    });
  };

  const handleInputChange = (event) => {
    const { value, name } = event.target;

    if (name.includes('_other')) {
      let key = name.replace('_other', '');
      setFormData({
        ...formData,
        [key]: {
          ...formData.key,
          other: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setErrors([]);

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_irrigation_current_practices',
        formData
      )
      .then((res) => {
        setLoading(false);
        setSuccess(res.data.data.message);
        setApplicationData(res.data.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-unit-form">
      <div className="fip-unit-form-fields">
        <div className="grid__col-xs-12 u--padding-left-0">
          <div className="form__field form__field--required">
            <label className="form__label">
              Which of the following crops do you irrigate and how many acres?
              (select all that apply)
            </label>
            {errors.crops && <RenderError error={errors.crops} />}
            {Object.entries(engineUseCrops).map((crop) => (
              <div key={crop[0]}>
                <label className="form__checkbox">
                  <input
                    type="checkbox"
                    value={crop[0]}
                    checked={crop[0] in formData.crops}
                    onChange={handleCheckCrop}
                  />
                  {crop[1]}
                </label>
                {crop[0] in formData.crops && (
                  <div className="u--margin-top-10 u--margin-left-10">
                    <input
                      type="number"
                      value={formData.crops[crop[0]]}
                      onChange={(event) => setCropAcres(event, crop[0])}
                      className="u--margin-right-10"
                    />
                    <label className="form__label">Number of Acres</label>
                    {errors[crop[0]] && <RenderError error={errors[crop[0]]} />}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              How many irrigation engines did you/do you own before purchasing
              your new propane-fueled engine? (Please enter 0 if none)
            </label>
            <input
              type="number"
              className="form__input form__input--lg"
              value={formData.numberOfEngines}
              name="numberOfEngines"
              onChange={handleInputChange}
            />
            {errors.numberOfEngines && (
              <RenderError error={errors.numberOfEngines} />
            )}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              Please provide the following information about your current
              engines:
            </label>
            <span className="u--margin-right-10">
              On average, how many hours does each engine operate in a typical
              year?
            </span>
            <input
              type="number"
              value={formData.operationHoursPerYear}
              className="form__input form__input--lg u--margin-bottom-10"
              name="operationHoursPerYear"
              onChange={handleInputChange}
            />
            {errors.hoursPerYear && <RenderError error={errors.hoursPerYear} />}
            <span className="u--margin-right-10">
              On average, how many gallons of fuel/kW per hour does each engine
              require to operate in a typical year?
            </span>
            <input
              type="number"
              value={formData.operationGallonsPerHour}
              className="form__input form__input--lg u--margin-bottom-10"
              name="operationGallonsPerHour"
              onChange={handleInputChange}
            />
            {errors.gallonsPerHour && (
              <RenderError error={errors.gallonsPerHour} />
            )}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              What type of maintenance do your engines typically require each
              year and how often? (select all that apply)
            </label>
            {errors.maintenance && <RenderError error={errors.maintenance} />}
            {Object.entries(engineUseMaintenance.questions).map((task) => (
              <div key={task[0]}>
                <label className="form__checkbox">
                  <input
                    type="checkbox"
                    value={task[0]}
                    checked={task[0] in formData.maintenance}
                    onChange={handleCheckTask}
                  />
                  {task[1]}
                </label>
                {task[0] in formData.maintenance && (
                  <div className="form__select u--margin-top-10 u--margin-left-10">
                    {task[0] !== 'other' ? (
                      <select
                        defaultValue={formData.maintenance[task[0]]}
                        onChange={(event) =>
                          setMaintenanceInterval(event, task[0])
                        }
                      >
                        <option value="">Frequency of maintenance</option>
                        {Object.entries(engineUseMaintenance.selectOptions).map(
                          (option) => (
                            <option key={option[0]} value={option[0]}>
                              {option[1]}
                            </option>
                          )
                        )}
                      </select>
                    ) : (
                      <div className="form__field form__field--required u--margin-bottom-0">
                        <textarea
                          className="form__textarea"
                          value={formData.maintenance[task[0]]}
                          name="maintenance_other"
                          onChange={(event) =>
                            setMaintenanceInterval(event, task[0])
                          }
                          placeholder="Please Specify"
                        />
                      </div>
                    )}
                    {errors[task[0]] && <RenderError error={errors[task[0]]} />}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="form__field form__field--required">
            <label
              className="form__label u--margin-right-20"
              htmlFor="maintenanceProvider"
            >
              Who typically performs engine maintenance? (select one)
            </label>
            {errors.maintenanceProvider && (
              <RenderError error={errors.maintenanceProvider} />
            )}
            <label className="form__radio">
              <input
                type="radio"
                name="maintenanceProvider"
                value="company"
                onChange={handleInputChange}
                checked={
                  formData.maintenanceProvider === 'company' && 'checked'
                }
              />
              My company or employee(s)
            </label>
            <label className="form__radio">
              <input
                type="radio"
                name="maintenanceProvider"
                value="dealership"
                onChange={handleInputChange}
                checked={
                  formData.maintenanceProvider === 'dealership' && 'checked'
                }
              />
              My dealership or local service center
            </label>
          </div>
          <Submit
            loading={loading}
            handleSubmit={handleSubmit}
            text="Save Section"
            errors={errors}
            disabled={!Boolean(aid)}
          />
          {success && <Success success={success} />}
        </div>
      </div>
    </div>
  );
}

CurrentPractices.displayName = 'CurrentPractices'; // because WebPack renames the function
export default CurrentPractices;
